<section class="hospital-filters-section" style="padding: 40px 3px 3px 0; margin-left: 29px;">
    <div class="">
        <div class="d-flex">
            <div class="filters-heading me-2">Filters</div>
            <mat-chip class="reset-chip" (click)="resetFilters()">
                <img src="/assets/images/hospital-filters-reset.svg" alt="hospital-filters-reset"
                class="me-1">Reset
            </mat-chip>
        </div>

        <div class="card mt-3" style="height: 95%; ">
                  <div class="card-body">
                      <form [formGroup]="filterForm"  >

                          <div class="filter-field-container">
                              <div class="filter-label mb-3">Your Search Keyword</div>

                              <mat-chip-grid #chipList>
                                  <div *ngFor="let controlName of filterControls">
                                    <mat-chip-row *ngFor="let item of filterForm.get(controlName)?.value" 
                                    class="reset-chip" [selectable]="selectable" [removable]="removable" 
                                     (removed)="remove(controlName, item)">
                                      <!-- {{ item }} -->
                                      {{ item.label ? (item.label | truncateText: 8) : (item | truncateText: 8)}}
                                      <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                                    </mat-chip-row>
                                  </div>
                                  <label class="input-container w-100">
                                    <mat-icon matPrefix class="inp">search</mat-icon>
                                    <input matInput [matChipInputFor]="chipList" placeholder="Search By Keyword"
                                           [value]="textFromUniversalSearch ? textFromUniversalSearch : ''"
                                           [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                                           [matChipInputAddOnBlur]="addOnBlur" (matChipInputTokenEnd)="add('keywords', $event)"
                                           (input)="searchSuggestionDebouncer($event)" autocomplete="new-password" >
                                  </label>
                                  
                                  <!-- <div *ngIf="searchSuggestionList && searchSuggestionList.length > 0" class="search-suggestions">
                                    <ul>
                                      <li *ngFor="let suggestion of searchSuggestions">
                                        <p (click)="selectedSuggestion(suggestion)"> {{ suggestion.name }} </p>
                                      </li>
                                    </ul>
                                  </div>
                               -->

                               <div *ngIf="isSugestionOpen && searchSuggestions.length > 0" class="search-suggestions">
                                <ul>
                                  <li *ngFor="let suggestion of searchSuggestions" (click)="selectedSuggestion(suggestion)">
                                    {{ suggestion.name }}
                                  </li>
                                </ul>
                              </div>

                              </mat-chip-grid>
                          </div>

                          <div class="filter-field-container">
                            <mat-expansion-panel>
                                <mat-expansion-panel-header>
                                    <mat-panel-title class="filter-label"> Region </mat-panel-title>
                                </mat-expansion-panel-header>
                               
                                  <mat-form-field appearance="outline" class="input-font w-100">
                                    <input matInput   [matAutocomplete]="countryAuto" placeholder="Search for country" [formControl]="countryControl" autocomplete="new-password" />
                                    <mat-autocomplete #countryAuto="matAutocomplete" (optionSelected)="onOptionSelected($event, 'country')">
                                        <mat-option *ngFor="let country of filteredCountries" [value]="country">
                                            {{ country?.countryName }}
                                        </mat-option>
                                    </mat-autocomplete>
                                </mat-form-field>
                                <mat-form-field appearance="outline" class="input-font w-100">
                                    <input matInput [matAutocomplete]="stateAuto" placeholder="Search for state" [formControl]="stateControl" autocomplete="new-password" />
                                    <mat-autocomplete #stateAuto="matAutocomplete" (optionSelected)="onOptionSelected($event, 'state')">
                                        <mat-option *ngFor="let state of filteredStates" [value]="state">
                                            {{ state?.stateName }}
                                        </mat-option>
                                    </mat-autocomplete>
                                </mat-form-field>
                                <mat-form-field appearance="outline" class="input-font w-100">
                                    <input matInput [matAutocomplete]="cityAuto" placeholder="Search for city" [formControl]="cityControl" autocomplete="new-password" />
                                    <mat-autocomplete #cityAuto="matAutocomplete" (optionSelected)="onOptionSelected($event, 'city')">
                                        <mat-option *ngFor="let city of filteredCities" [value]="city">
                                            {{ city?.cityName }}
                                        </mat-option>
                                    </mat-autocomplete>
                                </mat-form-field>

                                  <mat-form-field appearance="outline" class="input-font w-100">
                                      <input matInput multiple placeholder="Search By Zip Code" formControlName="zipCode" autocomplete="new-password">
                                  </mat-form-field>
                            </mat-expansion-panel>
                        </div>

                        <div class="filter-field-container">
                            <mat-expansion-panel>
                                <mat-expansion-panel-header>
                                    <mat-panel-title class="filter-label">  {{ this.dataObj[0]?.accountName === 'Doctor' ? 'Years of Experience' : 'Years in Market' }} </mat-panel-title>
                                </mat-expansion-panel-header>
                                <mat-slider min="0" [max]="dataObj[0]?.accountName === 'Doctor' ? 60 : 300"  class="w-100">
                                    <input  formControlName="yearFrom" matSliderStartThumb>
                                    <input formControlName="yearTo" matSliderEndThumb>
                                 
                                </mat-slider>
                                <p>
                                    From {{filterForm.get('yearFrom')?.value}} to {{filterForm.get('yearTo')?.value}} Years
                                  </p>
                                  
                            </mat-expansion-panel>
                        </div>

                        <div class="filter-field-container filter-field-container-spec">
                            <mat-expansion-panel>
                                <mat-expansion-panel-header>
                                    <mat-panel-title class="filter-label"> By Specialization</mat-panel-title>
                                </mat-expansion-panel-header>
                                <!-- <mat-form-field appearance="outline" class="input-font w-100"> -->
                                    <!-- <mat-select multiple placeholder="Select By Category"
                                        formControlName="specializations"
                                        panelClass="my-select"
                                        [disableOptionCentering]="true"
                                        [scrollStrategy]="'reposition'">
                                        <mat-option *ngFor="let specialization of specializations"
                                            [value]="specialization.name">{{ specialization?.name }}
                                        </mat-option>
                                    </mat-select> -->
                                    <!-- <input matInput placeholder="Search for specialization" (input)="showSpecialization($event)" formControlName="specializations" /> -->
                                    <!-- formControlName="specializations"
                                     (change)="onSpecializationChange(specialization.name, $event.checked)" -->
                                    <!-- <div class="specialization-dropdown"  style="height: 500px;" >
                                        <p *ngFor="let specialization of dropDownSpecializations" >
                                            <mat-checkbox class="specialization-checkbox" (change)="onSpecializationChange($event, specialization.name)" [checked]="checkedSpecialization.includes(specialization.name)" >{{ specialization.name }}</mat-checkbox>
                                        </p> 
                                    </div> -->

                                    <mat-form-field appearance="outline" class="input-font w-100">
                                        <input matInput [matAutocomplete]="specializationAuto" placeholder="Search for Specialization" [formControl]="specializationControl"  />
                                        <mat-autocomplete #specializationAuto="matAutocomplete" (optionSelected)="onOptionSelected($event, 'specialization')">
                                            <mat-option *ngFor="let specialization of filteredSpecialization" [value]="specialization">
                                                {{ specialization.name }}
                                            </mat-option>
                                        </mat-autocomplete>
                                    </mat-form-field>

                                <!-- </mat-form-field> -->
                            </mat-expansion-panel>
                        </div>
                      </form>
                    </div>
                    </div>
    </div>
</section>